export const MENU_HEADER = [
  {
    name: 'SunParadiseLand.header-eat-play-shoping',
    link: '',
    icon: 'far fa-flower',
    subMenu: true,
    children: [
      {
        link: 'an-uong',
        name: 'SunParadiseLand.header-eat',
      },
      {
        link: 'vui-choi',
        name: 'SunParadiseLand.header-play',
      },
      {
        link: 'mua-sam',
        name: 'SunParadiseLand.header-shoping',
      },
    ],
  },
  {
    name: 'SunParadiseLand.header-hotel',
    link: 'luu-tru',
    icon: 'fa-solid fa-fork-knife',
  },
  {
    name: 'SunParadiseLand.header-destination',
    link: 'diem-den',
    icon: 'fa-regular fa-cable-car',
    subMenu: true,
    children: [],
  },
  {
    name: 'SunParadiseLand.header-new',
    link: 'tin-tuc',
    icon: 'fa-regular fa-newspaper',
  },
  // {
  //   name: 'Hoạt động',
  //   link: 'hoat-dong',
  //   icon: 'fa-regular fa-dharmachakra',
  // },
];

export const MENU_HEADER_MOBI = [
  {
    name: 'SunParadiseLand.header-eat',
    link: 'an-uong',
    icon: 'far fa-flower',
    subMenu: true,
  },
  {
    name: 'SunParadiseLand.header-play',
    link: 'vui-choi',
    icon: 'far fa-flower',
    subMenu: true,
  },
  {
    name: 'SunParadiseLand.header-shoping',
    link: 'mua-sam',
    icon: 'far fa-flower',
    subMenu: true,
  },
  {
    name: 'SunParadiseLand.header-hotel',
    link: 'luu-tru',
    icon: 'fa-solid fa-fork-knife',
  },
  {
    name: 'SunParadiseLand.header-destination',
    link: 'diem-den',
    icon: 'fa-regular fa-cable-car',
  },
  {
    name: 'SunParadiseLand.header-new',
    link: 'tin-tuc',
    icon: 'fa-regular fa-newspaper',
  },
];
